import { MenuOptionType } from "@dexteel/mesf-core";
import EditIcon from "@mui/icons-material/Edit";
import { WaterAccountAllocationRow } from "../models/WaterAccountAllocationDraft";

type Props = {
	setSelectedRowData: (row: WaterAccountAllocationRow) => void;
	setShowModal: (modal: "update" | "") => void;
};

export const useAllocationsOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: WaterAccountAllocationRow) => {
		const options: MenuOptionType[] = [];

		if (data) {
			options.push({
				name: "Edit Split",
				key: "edit_split",
				onClick: () => {
					setSelectedRowData(data);
					setShowModal("update");
				},
				icon: <EditIcon />,
			});
		}

		return options;
	};

	return { getMenuOptions };
};
